module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24044",
      "conversations-internal-schema": "static-1.11754",
      "head-dlb": "static-1.4210",
      "hs-test-utils": "static-1.7114",
      "hubspot-url-utils": "static-1.3401",
      "HubStyleTokens": "static-2.10635",
      "I18n": "static-7.1417",
      "jasmine-runner": "static-1.5538",
      "quartz": "static-1.5881",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.470",
      "visitor-ui-component-library": "static-1.5306",
      "enviro": "static-4.313",
      "hs-promise-rejection-tracking": "static-1.4568",
      "PortalIdParser": "static-2.291",
      "raven": "static-3.5037",
      "raven-hubspot": "static-1.5344",
      "bend-plugin-trellis-migration": "static-1.2715",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1263",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3674",
      "quartz-core": "static-1.5100",
      "transmute": "static-2.29",
      "HeadJS": "static-2.600",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6499",
      "framer-motion": "static-1.44",
      "hs-test-utils-bend-plugin": "static-1.2225",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.126",
      "foundations-theming": "static-1.3426",
      "i18n-data": "static-1.202",
      "metrics-js": "static-1.8876",
      "moment-timezone": "static-5.58",
      "react-utils": "static-2.4575",
      "jasmine": "static-4.3466",
      "quartz-core-utils": "static-1.2748",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.42",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7582",
      "visitor-ui-component-library-icons": "static-1.5117",
      "rpc-client-utils": "static-1.3855",
      "ts-schema": "static-1.3364",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "copilot-toolkit": "static-1.8205",
      "dispatcher": "static-1.117",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.672",
      "hub-http-shared-msw-handlers": "static-1.7502",
      "hubspotter-http": "static-1.3838",
      "hubspotter-http-shared-msw-handlers": "static-1.7500",
      "icons": "static-2.593",
      "mobile-manifest-mixins": "static-1.371",
      "platform-navigation-bootstrap": "static-1.11543",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15681",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "bend-plugin-foundations-components": "static-1.2768",
      "floating-ui": "static-1.32",
      "foundations-assets": "static-1.4019",
      "foundations-theming-specialty": "static-1.1143",
      "hs-story-utils": "static-1.8482",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.77",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.919",
      "bend-plugin-foundations-theming": "static-1.1909",
      "foundations-theming-base": "static-1.2411",
      "classnames": "static-2.10",
      "cssUtils": "static-1.556",
      "HubStyle": "static-2.10943",
      "chatspot-client-types": "static-1.9386",
      "chatspot-core": "static-1.17589",
      "sassPrefix": "static-1.136",
      "platform-infra-nav-components": "static-1.6949",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24044",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11754",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-test-utils": "/hs-test-utils/static-1.7114",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3401",
      "HubStyleTokens": "/HubStyleTokens/static-2.10635",
      "I18n": "/I18n/static-7.1417",
      "jasmine-runner": "/jasmine-runner/static-1.5538",
      "quartz": "/quartz/static-1.5881",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.470",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5306",
      "enviro": "/enviro/static-4.313",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "raven": "/raven/static-3.5037",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2715",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1263",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3674",
      "quartz-core": "/quartz-core/static-1.5100",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.600",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6499",
      "framer-motion": "/framer-motion/static-1.44",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2225",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.126",
      "foundations-theming": "/foundations-theming/static-1.3426",
      "i18n-data": "/i18n-data/static-1.202",
      "metrics-js": "/metrics-js/static-1.8876",
      "moment-timezone": "/moment-timezone/static-5.58",
      "react-utils": "/react-utils/static-2.4575",
      "jasmine": "/jasmine/static-4.3466",
      "quartz-core-utils": "/quartz-core-utils/static-1.2748",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.42",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7582",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5117",
      "rpc-client-utils": "/rpc-client-utils/static-1.3855",
      "ts-schema": "/ts-schema/static-1.3364",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "copilot-toolkit": "/copilot-toolkit/static-1.8205",
      "dispatcher": "/dispatcher/static-1.117",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.672",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7502",
      "hubspotter-http": "/hubspotter-http/static-1.3838",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7500",
      "icons": "/icons/static-2.593",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.371",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11543",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15681",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2768",
      "floating-ui": "/floating-ui/static-1.32",
      "foundations-assets": "/foundations-assets/static-1.4019",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1143",
      "hs-story-utils": "/hs-story-utils/static-1.8482",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.77",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.919",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1909",
      "foundations-theming-base": "/foundations-theming-base/static-1.2411",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.556",
      "HubStyle": "/HubStyle/static-2.10943",
      "chatspot-client-types": "/chatspot-client-types/static-1.9386",
      "chatspot-core": "/chatspot-core/static-1.17589",
      "sassPrefix": "/sassPrefix/static-1.136",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6949",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};